<template>
    <div class="a-table--really-wide">
        <h1>{{name}}</h1>
        <h3>{{description}}</h3>
        <table class="a-table a-table--modal" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
                <th style="cursor: pointer" @click="selectColumn(index)" @mouseover="hoverColumn(index)" v-for="(header, index) in headers">
                    {{ header }}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr @click="selectRow(key)" v-for="(row, key, index) in tableData"
                :class="[highlightColumn(key, index), lightHighlightColumn(key, index)]">
                <td @mouseover="hoverRow(key)" style="cursor: pointer">
                    {{key}}
                </td>
                <td v-for="(column, index) in row" :class="[highlightColumn(key, index), lightHighlightColumn(key, index) ]">
                    {{column}}
                </td>
                <td style="cursor: pointer">
                    {{key}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    import Selector from 'pages/resources-and-tools/OgdenTables/mixins/Selector';
    export default {
        props: [
            'tableData',
            'name',
            'description'
        ],
        mixins: [
            Selector
        ],
        data() {
            return {
                headers: [
                    'Age at Date of Trial', '-2.00%', '-1.50%', '-1.00%', '0.75%', '-0.50%','-0.25%', '0.00%', '0.50%', '1.00%', '-1.50%', '2.00%', '2.50%', '3.00%', 'Age at Date of Trial',
                ],
                selectedColumn: null,
                selectedRow: null
            }
        },
    }

</script>


// WEBPACK FOOTER //
// OgdenTableViewer.vue?a461b87c